import React from 'react';

export type DrawingMode = 'select' | 'rectangle';

interface DrawingModeContextValue {
  drawingMode: DrawingMode;
  setDrawingMode?: (mode: DrawingMode) => void;
}

export const DrawingModeContext = React.createContext<DrawingModeContextValue>({
  drawingMode: 'select',
});
